import React from 'react';

const SvgPlane = props => (
  <svg width="20" viewBox="0 0 1000 1000" {...props}>
    <path
      fill={props.color}
      d="M895.12 163.35c-44.82 16.54-259.69 94.24-477.48 172.77C-16.08 492.78 10.31 482.31 10.31 499.69c0 6.07 1.47 9.84 5.86 14.45 5.86 6.7 139.27 98.43 145.13 100.1 2.51.63 528.58-274.55 631.83-330.47 8.17-4.61 15.08-7.96 15.08-7.54 0 .63-122.93 92.78-273.3 204.82l-273.3 203.98.63 85.03c.42 80.42.63 85.44 4.4 89.63 2.3 2.51 6.49 4.4 9.42 4.4 3.56 0 26.39-14.03 66.6-40.84 33.72-22.41 61.78-40.84 62.41-40.84.42 0 28.48 18.85 62.2 41.88 55.71 37.9 62.2 41.88 70.16 41.88 6.91 0 10.26-1.26 15.08-5.86 3.35-3.14 22.83-33.51 43.35-67.44 31.2-51.94 243.77-402.51 361.46-596.23 18.43-30.37 33.09-56.75 32.67-58.64-.42-2.51-2.72-3.98-6.91-4.19-3.56-.19-41.46 12.58-87.96 29.54z"
    />
  </svg>
);

export default SvgPlane;
